export enum LogoutReason {
  NotAuthenticated = 1, // A 'generic' reason, used when a more suitable message / reason is not available
  NoCookieAccess = 2, // Safari prevents accessing localStorage which we need to reauthenticate users
}
